export const highlightText = (originStr, query) => {
  if (originStr && query) {
    const indexStart = originStr.toLowerCase().indexOf(query.toLowerCase());

    if (indexStart === -1) return originStr;

    const beforeStr = originStr.substring(0, indexStart);
    const middle = originStr.substring(
      beforeStr.length,
      beforeStr.length + query.length
    );
    const afterStr = originStr.substring(beforeStr.length + query.length);

    return (
      beforeStr +
      '<mark style="background-color: yellow; padding: 0"">' +
      middle +
      "</mark>" +
      afterStr
    );
  }
};
